function getServices(json) {
    return {
        type: "APPOINTMENT_SERVICE",
        data: json,
    }
}

export function LoadServices() {
    return (dispatch) => {
        fetch(`/api/get-services`)
            .then(
                function(response) {
                    if (response.status !== 200) {
                        dispatch({
                            type: 'SCHEDULE_LOAD_FAIL',
                            payload: {
                                error_code: response.status
                            }
                        });
                    }
                    response.json().then(function(data) {
                        return dispatch(getServices(data));
                    });
                }
            )
            .catch(function(err) {
                dispatch({
                    type: 'SCHEDULE_PARSE_ERROR',
                    payload: {
                        error: err
                    }
                });
            });
    }
}



// WEBPACK FOOTER //
// frontend/src/actions/Services.js